import { USER_IS_LOGIN_STORE_KEY, USER_ID_COOKIES_KEY, USER_TOKEN_COOKIES_KEY } from "@/utils/constant";
import { getStorage, removeStorage, setStorage } from '@/utils/tools'
import { Mask } from "@/components/mask/index";
import Vue, {ref} from 'vue'
import './index.css'
import { fetchLogin, fetchRegister, fetchGetTmpUuid } from '@/api'
import Cookies from "js-cookie";
import { Toast } from 'vant';


export const isCurLogin = ref(false)


export class Login {
  constructor() {
  }

  isLogin() {
    return +getStorage(USER_IS_LOGIN_STORE_KEY) === 1
  }

   async logout() {
    removeStorage(USER_IS_LOGIN_STORE_KEY)
    Toast('Logout success')
    Cookies.remove(USER_ID_COOKIES_KEY)
    Cookies.remove(USER_TOKEN_COOKIES_KEY)
    isCurLogin.value = false
    return await fetchGetTmpUuid();
  }

  initLoginView(successCallback = function(){}) {
    const that = this
    this.mask = new Mask({
      maskStyle: 'z-index: 999;',
      closeOnClickOverlay: false,
      isDestroy:true,
      slot: () => {
        return Vue.extend({
          data() {
            return {
              flag: 'login',
              userName: '',
              password: '',
            }
          },
          methods: {
            handleClickClose() {
              that.mask.close()
            },
            handleCheckout() {
              this.flag = this.flag === 'login' ? 'register' : 'login'
              this.userName = ''
              this.password = ''
            },

            async handleRegister() {
              const res = await fetchRegister({
                user_name: this.userName,
                password: this.password,
                tmp_user_id: Cookies.get(USER_ID_COOKIES_KEY)
              })
              Toast('Register success')
              this.handleCheckout()
              this.userName = ''
              this.password = ''
            },
            async handleLogin() {
              const res = await fetchLogin({
                user_name: this.userName,
                password: this.password,
              })
              Cookies.set(USER_ID_COOKIES_KEY, res.user_id)
              Cookies.set(USER_TOKEN_COOKIES_KEY, res.accessToken)
              setStorage(USER_IS_LOGIN_STORE_KEY, 1)
              Toast('Login success')
              isCurLogin.value = true;
              setTimeout(() => {
                that.mask.close()
                successCallback();
              }, 500);
            },
            handleClickBtn() {
              if(this.userName === '' || this.password === '') {
                Toast('Username or Password cannot be empty')
                return
              }
              if(this.userName.length < 8 || this.password.length < 8) {
                Toast('Username or Password length must be greater than 8')
                return
              }
              if(this.flag === 'login') {
                this.handleLogin()
              } else {
                this.handleRegister()
              }
            }
          },  
          render() {
            return (
              <div class="top-img pages login-pages">
                <div class={['login-nav', 'flex', 'items-center']}>
                  <img src="https://static.novelfreedom.com/paynovel/h5-pay-asia/icon_arrowL.png" alt="" onClick={() => this.handleClickClose()}/>
                </div>
                <div class="login-logo flex justify-center items-center">
                  <img src="https://static.novelfreedom.com/paynovel/h5-pay-asia/logo.png" alt="" />
                    Novelfreedom
                </div>
                <div class="login-content">
                  <div class="login-content-title">{this.flag === 'login'? 'Login' : 'Register'}</div>
                  <div class="login-input flex items-center">
                    <img src="https://static.novelfreedom.com/paynovel/h5-pay-asia/user-icon.png" alt="" />
                      <input type="text" placeholder="User" value={this.userName} onInput={e => {
                        this.userName = e.target.value
                      }}/>
                  </div>
                  <div class="login-input flex items-center">
                    <img src="https://static.novelfreedom.com/paynovel/h5-pay-asia/password.png" alt="" />
                      <input type="password" placeholder="PassWord" value={this.password} onInput={e => {
                        this.password = e.target.value
                      }}/>
                  </div>
                </div>
                <div class={['login-btn', 'flex', 'justify-center', 'items-center', 'mx-auto', this.userName.length > 0 ? 'login-btn__active' : 'login-btn__none']} 
                  onClick={() => this.handleClickBtn()}
                >
                  {this.flag === 'login'? 'Login' : 'Register'}
                </div>
                <div class="login-checkout" onClick={() => this.handleCheckout()}>
                  {this.flag === 'login' ? 'Register' : 'Login'}
                </div>
                <div class="login-text text-center w-full">
                  By continuing, you agree with the <a onClick={() => {
                    window.location.href = window.location.origin + '/privacy'
                  }}>Privacy Policy</a> and <a onClick={() => {
                    window.location.href = window.location.origin + '/service'
                  }}>Terms of Servise</a>
                </div>
              </div>
            )
          }
        })
      },
    })
    this.mask.init();
  }

  showLoginView() {
    this.mask.show()
  }
}

export const login = new Login()